import { patchProfile } from '@zr/utilities/api/profile';

export async function patchProfileForm(values, { setErrors, setSubmitting }, cb, onError) {
  try {
    await patchProfile(values);
    // we need to await the callback, otherwise Formik thinks we submitted too early
    await cb();
  } catch (error) {
    if (error.data && error.data.error_code === 'validation_error') {
      setErrors(error.data.fields);
    } else {
      // if it's not a validation error, then show something generic
      onError(error);
    }
    setSubmitting(false);
  }
}

export default patchProfileForm;
